import { render, staticRenderFns } from "./DashboardNotificacoes.vue?vue&type=template&id=d7597960&scoped=true&"
import script from "./DashboardNotificacoes.vue?vue&type=script&lang=js&"
export * from "./DashboardNotificacoes.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNotificacoes.vue?vue&type=style&index=0&id=d7597960&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7597960",
  null
  
)

export default component.exports